import React from "react"
import { useModal } from "../../../hooks/ModalContext"
import { useDividas } from "../../../context/DividasContext"
import { useHibrido } from "../../../context/HibridoContext"
import { usePropostas } from "../../../context/PropostasContext"
import { useContrato } from "../../../context/ContratoContext"
import { useHistorico } from "../../../context/HistoricoContext"
import { useNeg } from "../../../context/NegContext"
import { useBoleto } from "../../../context/BoletoContext"

export const ManualButton = () => {
  const { devedorCadastro, clearDevedorCadastro, clearDividas } = useDividas()
  const { setModal } = useModal()
  const { dadosChamada } = useHibrido()
  const { clearPropostas } = usePropostas();
  const { clearContratos } = useContrato();
  const { clearHistorico } = useHistorico();
  const { clearParcelasNeg } = useNeg();
  const { clearBoleto } = useBoleto();

  function clearDatas() {
    clearPropostas();
    clearContratos();
    clearHistorico();
    clearBoleto();
    clearDevedorCadastro();
    clearParcelasNeg();
    clearDividas()
  }
  // !dadosChamada?.contrato
  return (
    <div >
      <button
        className="text-white bg-primary rounded-sm p-1 text-sm px-2 disabled:opacity-60"
        disabled={devedorCadastro?.cpfcnpj && dadosChamada?.call?.call_mode === 'manual' ? true : false}
        onClick={() => devedorCadastro?.cpfcnpj && dadosChamada?.call?.call_mode === 'manual' ? clearDatas() : setModal('Buscar Devedor', 'Buscar Devedor')}
      >{devedorCadastro?.cpfcnpj && dadosChamada?.call?.call_mode === 'manual' ? 'Limpar' : 'Pesquisar'}</button>
    </div>
  )
}